import React from 'react';
import Field from '../fields/Field';
import FieldSelect from '../fields/FieldSelect';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import DevWarning from '../common/DevWarning';

const FORM_LABEL = {
    OrderOnBehalfOf: getTranslation('FIELD.ORDER_ON_BEHALF_OF'),
    BusinessName: getTranslation('FIELD.BUSINESS_NAME'),
    TradingName: getTranslation('FIELD.TRADING_NAME'),
    FirstName: getTranslation('FIELD.FIRST_NAME'),
    Surname: getTranslation('FIELD.LAST_NAME'),
    Email: getTranslation('FIELD.EMAIL'),
    Phone: getTranslation('FIELD.PHONE'),
};

function CheckoutRecipientInformation(props) {
    const {
        memberType,
        formData,
        handleFormUpdate,
        orderOnBehalf,
        disableRecipientModification,
    } = props;

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <i className='icon icon-user-details' />
                    </span>
                </span>
                <h5 className='heading--lv5 heading'>Recipient Information</h5>
            </div>
            <div className='card__content'>
                <Field
                    isDisabled={disableRecipientModification}
                    disabled={disableRecipientModification}
                    label={FORM_LABEL['BusinessName']}
                    animatedLabel={FORM_LABEL['BusinessName']}
                    name='BusinessName'
                    value={formData.BusinessName || ''}
                    onChange={handleFormUpdate}
                />
                <div className='row row--small'>
                    <div className='col-xs-12 col-md-6'>
                        <Field
                            required
                            isDisabled={disableRecipientModification}
                            disabled={disableRecipientModification}
                            label={FORM_LABEL['FirstName']}
                            animatedLabel={FORM_LABEL['FirstName']}
                            name='FirstName'
                            value={formData.FirstName || ''}
                            onChange={handleFormUpdate}
                        />
                    </div>
                    <div className='col-xs-12 col-md-6'>
                        <Field
                            required
                            isDisabled={disableRecipientModification}
                            disabled={disableRecipientModification}
                            label={FORM_LABEL['Surname']}
                            animatedLabel={FORM_LABEL['Surname']}
                            name='Surname'
                            value={formData.Surname || ''}
                            onChange={handleFormUpdate}
                        />
                    </div>
                </div>
                <div className='row row--small'>
                    <div className='col-xs-12 col-md-6'>
                        <Field
                            required
                            isDisabled={disableRecipientModification}
                            disabled={disableRecipientModification}
                            label={FORM_LABEL['Email']}
                            animatedLabel={FORM_LABEL['Email']}
                            name='Email'
                            value={formData.Email || ''}
                            onChange={handleFormUpdate}
                        />
                    </div>
                    <div className='col-xs-12 col-md-6'>
                        <Field
                            required
                            isDisabled={disableRecipientModification}
                            disabled={disableRecipientModification}
                            label={FORM_LABEL['Phone']}
                            animatedLabel={FORM_LABEL['Phone']}
                            name='Phone'
                            value={formData.Phone || ''}
                            onChange={handleFormUpdate}
                        />
                    </div>
                </div>
                <div className='text-box text-box--small'>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: getTranslation(
                                'CHECKOUT.RECIPIENT_INFORMATION.CHANGE_DETAIL_CONTENT'
                            ),
                        }}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default CheckoutRecipientInformation;
